// extracted by mini-css-extract-plugin
export default {"root":"_13Fg8","text-block":"_3x8B9","textBlock":"_3x8B9","prefix":"_9-kI8"};